<template>
    <v-card :loading="loading">
        <!-- Loading Overlay -->
        <v-overlay :value="loading" absolute z-index="999">
            <div class="text-center">
                <v-progress-circular
                    indeterminate
                    size="70"
                    width="7"
                    color="secondary"
                ></v-progress-circular>
                <div class="mt-4 white--text" style="font-size: 18px;">
                    {{ $t('LoadingResults') || 'Loading Results...' }}
                </div>
            </div>
        </v-overlay>

        <div class="card-title">
            {{ $t('SurveyResults') }}
        </div>
        <v-spacer />
        <router-link :to="{ name: 'survey-list'}" custom>
            <v-btn fab small class="white--text float-end" color="secondary" role="link" style="margin:14px;">
                <v-icon>mdi-arrow-left-circle</v-icon>
            </v-btn>
        </router-link>
        <v-card-text>
            <div>
                <h2> {{title}}</h2>
                <div class="white--text container-fluid mt-4">
                    <v-row>
                        <v-col md="6" cols="12">
                            <v-row>
                                <v-col md="6" cols="12">
                                    <DatePicker dense outlined v-model.lazy="startDate" :label="$t('StartDate')" />
                                </v-col>
                                <v-col md="6" cols="12">
                                    <DatePicker dense outlined v-model.lazy="expiryDate" :label="$t('ExpiryDate')" />
                                </v-col>
                                <v-col md="4" cols="12">
                                    <v-checkbox dense outlined v-model.lazy="trickyQuestionValidated" :label="$t('TrickyQuestionValidated')" />
                                </v-col>
                                <v-col md="4" cols="12">
                                    <v-checkbox dense outlined v-model.lazy="durationValidated" :label="$t('DurationValidated')" />
                                </v-col>
                                <v-col md="4" cols="12">
                                    <v-checkbox dense outlined v-model.lazy="patternValidated" :label="$t('PatternValidated')" />
                                </v-col>
                            </v-row>
                        </v-col>


                        <v-col md="6" cols="12">
                            <v-row class="float-start">
                                <v-col>
                                    <v-btn tile :loading="loadingExport" :disabled="loadingExport" color="primary darken-3" class="float-end white--text" @click="Search">
                                        <v-icon start dark size="25">
                                            mdi-search-web
                                        </v-icon>
                                        {{ $t('SEARCH') }}
                                    </v-btn>
                                </v-col>
                                <v-col>
                                    <v-btn tile :loading="loadingExport" :disabled="loadingExport" color="green darken-3" class="float-end white--text" @click="exportToExcel">
                                        <v-icon start dark size="25">
                                            mdi-microsoft-excel
                                        </v-icon>
                                        {{ $t('EXPORT') }}
                                    </v-btn>

                                </v-col>
                            </v-row>


                        </v-col>
                    </v-row>
                </div>
                <!--<v-btn v-if="isShow" tile :loading="loadingExport" :disabled="loadingExport" color="green darken-3" class="float-end white--text" @click="isExport=true;isShow=false;">
                <v-icon start dark size="25">
                    mdi-microsoft-excel
                </v-icon>
                {{ $t('EXPORTTOEXCEL') }}
            </v-btn>-->
            </div>
        </v-card-text>
        <v-card-text v-if="results.length > 0">
            <GridWithServerPaging :headers="headers" :items="results" :total="totalCount" disable-sort class="mt-8" @onChange="listSurveyresults">

                <template v-slot:[`item.user`]="{ item }">
                    <b class="primary--text">{{ item.user }}</b>
                </template>
                <template v-slot:[`item.longitude`]="{ item }">
                    {{ item.longitude }}
                </template>
                <template v-slot:[`item.latitude`]="{ item }">
                    {{ item.latitude }}
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-btn v-if="canEditAnswer" color="secondary" class="white--text" tile small :to="`/public-survey-form?id=${$route.params.id}&participantId=${item.id}&editMode=true`">
                        {{ $t("EditSurveyAnswer") }}
                    </v-btn>
                </template>
            </GridWithServerPaging>
        </v-card-text>
        <v-card-text v-else class="text-center">
            <span>{{ $t('NoItemsToShow') }}</span>
        </v-card-text>
        
    </v-card>
</template>

<script>
    import DatePicker from '@/components/controls/DatePicker.vue'
    import SurveyService from '@/services/SurveyService'
    import UsersService from '@/services/UsersService.js'
    import GridWithServerPaging from '@/components/controls/GridWithServerPaging.vue'
    import { downloadFile } from '@/helpers/downloader.js'
    import { useStripHtml } from '@/helpers/common.js'
    import { FormMethodEnum } from '@/helpers/constants/enumerations.js'

    import * as XLSX from 'xlsx'
    import { saveAs } from 'file-saver'

    export default {
        components: {
            GridWithServerPaging, DatePicker
        },

        data() {
            return {
                isExport: false,
                
                isShow:true,
                loadingExport: false,
                loading: true,
                surveyResult: null,
                options: {
                    page: 1,
                    itemsPerPage: 10
                },
                totalCount: 10,
                headers: [],
                results: [],
                title: '',
                canEditAnswer: false,
                startDate: '',
                expiryDate: '',
                trickyQuestionValidated: null,
                durationValidated:null,
                patternValidated:null
            }
        },

        created() {
            this.listSurveyresults()
            this.canEditAnswerPermission()
        },

        methods: {
            Search() {
                this.listSurveyresults()
            },
            canEditAnswerPermission() {
                UsersService.listCurrentUserPermissions().then((res) => {
                    if (res.data) {
                        this.canEditAnswer = res.data.some(userPermission => userPermission.name === 'EditSurveyAnswer')

                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    //this.loading = false
                })
            },
            exportToExcelFrontEnd() {
                const wsData = [
                    this.headers.map(header => header.text),
                    ...this.results.map(item => {
                        return this.headers.map(header => {
                            if (header.value in item) {
                                return item[header.value]
                            } else {
                                return ''
                            }
                        })
                    })
                ]
                const ws = XLSX.utils.aoa_to_sheet(wsData)
                const wb = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
                XLSX.writeFile(wb, 'export.xlsx')
            },
            exportToExcel() {
                this.loadingExport = true
                const fromDate = this.startDate
                const toDate = this.expiryDate
                SurveyService.exportToExcel(this.$route.params.id, fromDate, toDate, this.trickyQuestionValidated, this.durationValidated, this.patternValidated).then(res => {
                    downloadFile(res)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loadingExport = false
                })
            },
            exportToExcelForEdit() {
                this.loadingExport = true
                const fromDate = this.startDate
                const toDate = this.expiryDate
                SurveyService.exportToExcelForEdit(this.$route.params.id, fromDate, toDate, this.trickyQuestionValidated, this.durationValidated, this.patternValidated).then(res => {
                    downloadFile(res)
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loadingExport = false
                })
            },

            listSurveyresults(options) {
                if (this.$route.params.id) {
                    this.loading = true

                    const page = options != undefined || options == false ? options.page : 1
                    const pageSize = options != undefined ? options.itemsPerPage : 10

                    SurveyService.listSurveyResults(this.$route.params.id, page, pageSize, this.trickyQuestionValidated, this.durationValidated, this.patternValidated).then(res => {
                        if (res.data) {
                            this.headers = []
                            this.results = []
                            this.title = useStripHtml(res.data.title)
                            this.totalCount = res.data.totalCount
                            this.headers.push({ text: this.$t('Id'), value: 'id' })
                            this.headers.push({ text: this.$t('Username'), value: 'user' })
                            this.headers.push({ text: this.$t('Longitude'), value: 'longitude' })
                            this.headers.push({ text: this.$t('Latitude'), value: 'latitude' })
                            this.headers.push({ text: this.$t('AverageCompletion'), value: 'averageCompletion' })
                            this.headers.push({ text: this.$t('TrickyQuestionValidated'), value: 'trickyQuestionValidated' })
                            this.headers.push({ text: this.$t('DurationValidated'), value: 'durationValidated' })
                            this.headers.push({ text: this.$t('PatternValidated'), value: 'patternValidated' })
                            res.data.questions.map(x => {

                                if (x.parentId == null && x.questionTypeId != FormMethodEnum.PredefineDropdown && x.questionTypeId != FormMethodEnum.ContactForm) {
                                    var subquestions = res.data.questions.filter(z => z.parentId == x.id)
                                    if (subquestions.length == 0 && this.headers.filter(x => x.value == `q${x.id}`).length == 0)
                                        this.headers.push({ text: x.name, value: `q${x.id}` })
                                    else {
                                        subquestions.forEach(a => {
                                            if (this.headers.filter(x => x.value == `q${a.id}`).length == 0)
                                                this.headers.push({ text: x.name + ':' + a.name, value: `q${a.id}` })
                                        }
                                        )
                                    }
                                }

                            })
                            if (res.data.gisintegration == true) {
                                this.headers.push({ text: this.$t('municipality'), value: 'municipality' })
                                this.headers.push({ text: this.$t('subMunicipality'), value: 'subMunicipality' })
                                this.headers.push({ text: this.$t('district'), value: 'district' })
                                this.headers.push({ text: this.$t('street'), value: 'street' })

                            }
                            for (var i = 0; i < res.data.surveyParticipants.length; i++) {
                                const obj = {}
                                let item = res.data.surveyParticipants[i]
                                for (var j = 0; j < item.items.length; j++) {
                                    let subItem = item.items[j]
                                    let ref = `q${subItem.questionId}`
                                    var answers = item.items.filter(x => x.questionId == subItem.questionId)
                                    if (answers.length > 1) {
                                        var ans = ''
                                        answers.forEach(e =>
                                            ans += ', ' + e.answer
                                        )
                                        if (ans != '') {
                                            ans = ans.substr(1)
                                        }
                                        obj[ref] = ans
                                    }
                                    else {
                                        if (subItem.isPredefined) {
                                            var records = subItem.answer.split('|')
                                            records.map(r => {
                                                var q = r.split('-')[0]
                                                var a = r.split('-')[1]
                                                if (this.headers.filter(x => x.value == q).length == 0) {
                                                    this.headers.push({ text: q, value: q })

                                                }
                                                obj[q] = a
                                            })
                                        }
                                        else {
                                            obj[ref] = subItem.answer
                                        }
                                        if (res.data.questions.find(x => x.id == subItem.questionId && x.questionTypeId == FormMethodEnum.ContactForm)) {
                                            
                                                var answer = subItem.answer
                                                
                                                try {
                                                    var jsonData = JSON.parse(answer)
                                                    Object.entries(jsonData).forEach(([key, value]) => {
                                                        if(this.headers.filter(x => x.value == 'cf_'+key).length == 0) {
                                                            this.headers.push({ text: key, value: 'cf_' + key })

                                                        }
                                                        obj['cf_' + key] = value
                                                    })
                                                }
                                                catch {

                                                }
                                        }
                                    }
                                }
                                obj.id = `${item.id}`
                                obj.user = `${item.fullName || item.sourceIp}`
                                obj.longitude = `${item.longitude}`
                                obj.latitude = `${item.latitude}`
                                if (item.averageCompletion) { obj.averageCompletion = `${item.averageCompletion.split('.')[0]}` }
                               
                                obj.trickyQuestionValidated = item.trickyQuestionValidated
                                obj.durationValidated = item.durationValidated
                                obj.patternValidated = item.patternValidated
                                if (res.data.gisintegration == true) {
                                    obj.municipality = !item.locationData[0].locData || item.locationData[0].locData == '' ? '' : `${item.locationData[0].locData.split('|')[0].split(':')[1]}`
                                    obj.subMunicipality = !item.locationData[0].locData || item.locationData[0].locData == '' ? '' : `${item.locationData[0].locData.split('|')[1].split(':')[1]}`
                                    obj.district = !item.locationData[0].locData || item.locationData[0].locData == '' ? '' : `${item.locationData[0].locData.split('|')[2].split(':')[1]}`
                                    obj.street = !item.locationData[0].locData || item.locationData[0].locData == '' ? '' : `${item.locationData[0].locData.split('|')[3].split(':')[1]}`

                                }
                                this.results.push(obj)
                            }
                            if (this.canEditAnswer)
                                this.headers.push({ text: this.$t('Actions'), value: 'actions' })
                        }
                    }).catch((err) => {
                        alert(err.toString())
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                       this.loading = false
                    })
                }
            }
        },
    }
</script>

<style scoped>
    .odd {
        background: #fff !important
    }

    .custom-table {
        border-collapse: collapse;
        width: 100%;
    }

        .custom-table thead th {
            border: 1px solid #ccc;
            color: #fff !important;
            font-weight: normal !important;
            font-size: 12px !important
        }

    tbody tr:nth-of-type(2n) {
        background-color: #eceded !important;
    }
</style>